import React, {useState, useEffect} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    Zoom,
    Grid
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import {makeStyles} from "@material-ui/styles";
import NotificationElement from "./NotificationElement";
import Firebase from "firebase/app";

const Transition = React.forwardRef((props: TransitionProps & { children?: React.ReactElement<any, any>}, ref: React.Ref<unknown>) => {
    return <Zoom  ref={ref} {...props} />;
});

const FullNotificationDialog = (props: any) => {
    const {open, onClose, notificationID, updateReadStatus, updateDeletionStatus, index} = props;
    const classes = useStyles()
    const [notification, setNotification] = useState<any>();
    const controller = new AbortController()
    const signal = controller.signal;
    const getNotification = async () => {
        // console.log('get Note')
        try {
            let firebase_token = await Firebase.auth().currentUser.getIdToken();
            let response = await fetch(
                `https://idverify.manhattan.edu/apiv2/api/messagebox/view/${notificationID}`,
                {
                    signal,
                    headers: {
                        'Authorization': `Bearer ${firebase_token}`
                    }
                })
            let json = await response.json();
            setNotification({...json[0], READ: 'Y'})
        } catch (error) {
            // console.log(error)
        }

    }

    const updateReadStatusLocal = (status: 'Y' | 'N') => {
        setNotification({...notification, READ: status})
        // console.log(status, 'fullNotif')
    }

    const updateDeletionStatusLocal = (status: 'Y' | 'N') => {
        // setNotification({...notification, DELETED: status})
        updateDeletionStatus(index, status)
        onClose();
    }


    useEffect(() => {
        if (open)
            getNotification()
    }, [open])

    return (
        <Dialog
            open={open}
            scroll={'body'}
            onClose={() => {
                updateReadStatus(index, notification.READ)
                onClose()
                setNotification(undefined)
            }}

        >
            <Grid container
                  className={classes.container}
                  alignItems={'center'}
            >
                <Grid item xs={12} className={classes.containerItem} >
                    {notification &&
                    <Zoom in={notification !== undefined} >
                        <NotificationElement
                            notification={notification}
                            full
                            onSelect={() => {
                                onClose()
                                setNotification(undefined)
                            }}
                            updateReadStatus={updateReadStatusLocal}
                            updateDeletionStatus={updateDeletionStatusLocal}
                        />
                    </Zoom>
                    }

                </Grid>
            </Grid>
        </Dialog>
    )
}

const useStyles = makeStyles({
    container: {
        height: 'auto',
        width: 'auto',
        background: 'transparent',
    },
    containerItem: {
        background: 'transparent',

    }
})

export default FullNotificationDialog;